import { render } from "./captain-list-page.vue?vue&type=template&id=3e6e0b82&scoped=true"
import script from "./captain-list-page.vue?vue&type=script&lang=js"
export * from "./captain-list-page.vue?vue&type=script&lang=js"

import "./captain-list-page.vue?vue&type=style&index=0&id=3e6e0b82&scoped=true&lang=scss"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6e0b82"]])

export default __exports__